import React from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { getTranslations } from "../../../../services/languageUtils";

class Step1 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dangerName: false,
      dangerEmail: false,
      dangerPhone: false,
      dangerDoc: false,
      dangerMotherName: false,
      dangerBirthDate: false,
      translations: {},
    };
  }

  loadTranslations = async () => {
    const translations = await getTranslations(
      localStorage.getItem("language") || "pt",
    );
    this.setState({ translations });
  };

  componentDidMount() {
    this.loadTranslations();
  }

  validatePhoneFormat(phone) {
    const phoneRegex = /^\+\d{2} \d{2} \d{4,5}-\d{4}$/;
    return phoneRegex.test(phone);
  }

  maskPhone(value) {
    let cleanedValue = value.replace(/\D/g, "");

    if (cleanedValue.length > 13) {
      cleanedValue = cleanedValue.slice(0, 13);
    }

    if (cleanedValue.length > 0) {
      cleanedValue = `+${cleanedValue}`;
    }
    if (cleanedValue.length > 3) {
      cleanedValue = cleanedValue.replace(/(\+\d{2})(\d)/, "$1 $2");
    }
    if (cleanedValue.length > 6) {
      cleanedValue = cleanedValue.replace(/(\+\d{2} \d{2})(\d)/, "$1 $2");
    }
    if (cleanedValue.length > 11) {
      cleanedValue = cleanedValue.replace(
        /(\+\d{2} \d{2} \d{4,5})(\d{0,4})/,
        "$1-$2",
      );
    }

    return cleanedValue;
  }

  handlePhoneChange = (e) => {
    const formattedPhone = this.maskPhone(e.target.value);

    this.props.onChangeValue({
      target: { name: "phone", value: formattedPhone },
    });

    this.setState({ dangerPhone: false });
  };

  handlePEPChange = (e) => {
    this.props.onChangeValue({
      target: {
        name: "isPoliticallyExposedPerson",
        value: e.target.value === "true",
      },
    });
  };

  nextStep() {
    let hasError = false;
    const {
      name,
      email,
      phone,
      doc,
      motherName,
      birthDate,
      onChangeValue,
    } = this.props;
    const { translations } = this.state;

    try {
      if (!name || name.trim().length < 4) {
        this.setState({ dangerName: true });
        hasError = true;
      }

      const emailRegex = /\S+@\S+\.\S+/;
      if (!emailRegex.test(email || "")) {
        this.setState({ dangerEmail: true });
        hasError = true;
      }

      if (!phone || phone.length < 12 || !this.validatePhoneFormat(phone)) {
        this.setState({ dangerPhone: true });
        hasError = true;
        toast.error(translations.wrongPhone || "Telefone inválido.");
      }

      if (!doc || doc.replace(/\D/g, "").length < 11) {
        this.setState({ dangerDoc: true });
        hasError = true;
      }

      if (!motherName || motherName.trim().length < 5) {
        this.setState({ dangerMotherName: true });
        hasError = true;
      }

      if (!birthDate || birthDate.length < 5) {
        this.setState({ dangerBirthDate: true });
        hasError = true;
      }

      if (hasError) {
        toast.error(
          translations.incompleteData || "Preencha todos os campos corretamente.",
        );
        return;
      }

      onChangeValue({ target: { name: "step", value: 2 } });
    } catch (error) {
      console.error(error);
      toast.error(
        translations.incompleteData || "Preencha todos os campos corretamente.",
      );
    }
  }

  render() {
    const {
      name,
      phone,
      email,
      doc,
      birthDate,
      motherName,
      isPoliticallyExposedPerson,
    } = this.props;

    const {
      dangerName,
      dangerEmail,
      dangerPhone,
      dangerDoc,
      dangerMotherName,
      dangerBirthDate,
      translations,
    } = this.state;

    return (
      <div className="sideRightContent">
        <div className="textContentSteps">
          <div className="h1">
            <div className="h1Label">
              <img
                src={
                  require("../../../../assets/imgs/ico-higher-titulo.svg")
                    .default
                }
                alt="Logo Higher"
                className="titleImage"
              />
            </div>
            <div className="h1LabelMobile">1</div>
            {translations.identification || "Identificação"}
          </div>
          <br />

          <p className="h5">Dados de identificação</p>

          <div className="contentName">
            <p className="label">Nome completo</p>
            <input
              className={`input ${dangerName ? "inputDanger" : ""}`}
              value={name}
              type="text"
              name="name"
              maxLength="200"
              onChange={(e) => {
                this.props.onChangeValue(e);
                this.setState({ dangerName: false });
              }}
            />
          </div>

          <div className="contentPhone">
            <p className="label">Celular</p>
            <input
              inputMode="numeric"
              className={`input ${dangerPhone ? "inputDanger" : ""}`}
              type="text"
              name="phone"
              id="phone"
              value={phone || ""}
              onChange={this.handlePhoneChange}
              placeholder="+55 11 99999-9999"
            />
          </div>

          <p className="label">E-mail</p>
          <input
            className={`input ${dangerEmail ? "inputDanger" : ""}`}
            value={email}
            type="text"
            name="email"
            maxLength="100"
            onChange={(e) => {
              this.props.onChangeValue(e);
              this.setState({ dangerEmail: false });
            }}
          />

          <div className="contentName">
            <p className="label">CPF</p>
            <input
              inputMode="numeric"
              className={`input ${dangerDoc ? "inputDanger" : ""}`}
              value={doc}
              type="text"
              name="doc"
              onChange={(e) => {
                this.props.onChangeValue(e);
                this.setState({ dangerDoc: false });
              }}
            />
          </div>

          <div className="contentPhone">
            <p className="label">Data de nascimento</p>
            <input
              className={`input ${dangerBirthDate ? "inputDanger" : ""}`}
              value={birthDate}
              type="date"
              name="birthDate"
              onChange={(e) => {
                this.props.onChangeValue(e);
                this.setState({ dangerBirthDate: false });
              }}
            />
          </div>

          <div className="contentName">
            <p className="label">Nome da mãe</p>
            <input
              className={`input ${dangerMotherName ? "inputDanger" : ""}`}
              value={motherName}
              type="text"
              name="motherName"
              maxLength="200"
              onChange={(e) => {
                this.props.onChangeValue(e);
                this.setState({ dangerMotherName: false });
              }}
            />
          </div>

          <div className="contentPhone">
            <p className="label">Pessoa politicamente exposta?</p>
            <select
              className="select"
              name="isPoliticallyExposedPerson"
              value={String(isPoliticallyExposedPerson)}
              onChange={this.handlePEPChange}
            >
              <option value="true">Sim</option>
              <option value="false">Não</option>
            </select>
          </div>

          <div className="lineBtnSaveAndContinue">
            <div></div>
            <div
              className="btnSaveAndContinue"
              onClick={() => {
                this.nextStep();
              }}
            >
              {translations.saveAndProceed || "Salvar e continuar"}
              <div className="arrow">
                <img
                  src={
                    require("../../../../assets/imgs/seta-right-branca.svg")
                      .default
                  }
                  alt={translations.nextArrow || "Próximo"}
                  className="arrowNext"
                />
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
      </div>
    );
  }
}

export default Step1;


